/**
 * @generated SignedSource<<872a0b5fb4fd53edfedc9f74adc2b34a>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Mutation } from 'relay-runtime';
export type InternBrandJobsCleanupMutation$variables = {
  days: number;
};
export type InternBrandJobsCleanupMutation$data = {
  readonly cleanupOldJobs: {
    readonly deletedCount: number;
    readonly message: string;
  };
};
export type InternBrandJobsCleanupMutation = {
  response: InternBrandJobsCleanupMutation$data;
  variables: InternBrandJobsCleanupMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "days"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "days",
        "variableName": "days"
      }
    ],
    "concreteType": "JobCleanupResult",
    "kind": "LinkedField",
    "name": "cleanupOldJobs",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "deletedCount",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "message",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "InternBrandJobsCleanupMutation",
    "selections": (v1/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "InternBrandJobsCleanupMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "7b1e501e5d8dbcd3879c0d2aa5e1ff40",
    "id": null,
    "metadata": {},
    "name": "InternBrandJobsCleanupMutation",
    "operationKind": "mutation",
    "text": "mutation InternBrandJobsCleanupMutation(\n  $days: Int!\n) {\n  cleanupOldJobs(days: $days) {\n    deletedCount\n    message\n  }\n}\n"
  }
};
})();

(node as any).hash = "f4840b9f10725a75dc5d346d96f942ea";

export default node;
